import { _ as __rest } from '../tslib.es6-c563c1dd.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import { Grid, Button, SvgIcon, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PREFIX = 'TitleBack';
const classes = {
    root: `${PREFIX}-root`,
    arrowButton: `${PREFIX}-arrowButton`,
};
const StyledGrid = styled(Grid)(({ theme }) => ({
    [`&.${classes.root}`]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`& .${classes.arrowButton}`]: {
        minWidth: '40px',
        color: theme.palette.text.secondary,
    },
}));
const TitleBack = (_a) => {
    var { title, handleBack } = _a, rest = __rest(_a, ["title", "handleBack"]);
    return (jsxs(StyledGrid, Object.assign({ item: true, md: 12, sm: 12, xs: 12, className: classes.root }, rest, { children: [jsx(Button, Object.assign({ onClick: handleBack, className: classes.arrowButton }, { children: jsx(SvgIcon, Object.assign({ fontSize: "small" }, { children: jsx(ArrowBackIcon, {}) })) })), jsx(Typography, Object.assign({ variant: "h3", color: "textPrimary" }, { children: title }))] })));
};

export { TitleBack };
